import { Component } from '@angular/core';

@Component({
  selector: 'app-wallet-export',
  templateUrl: './wallet-export.component.html',
  styleUrls: ['./wallet-export.component.scss']
})
export class WalletExportComponent {

}
